export const ru = {
    'default-error': 'Что-то не так с баннером',
    'new-banner': 'Новое объявление',
    'wrong-place-id': 'У кампании указан неверный Place Id'
};
